import Marquee from "react-fast-marquee";
import { LotusMark } from "@/components/site/Brand";

const WORDS = ["Nurture", "Hope", "Fertility", "Serenity", "New Beginnings", "Care", "Healing", "Trust", "Warmth"];

export default function BrandMarquee() {
  return (
    <section className="py-10 bg-blush-pale/60 border-y border-blush/30 overflow-hidden" data-testid="marquee">
      <Marquee speed={40} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <div key={i} className="flex items-center gap-8 px-8">
            <span className="font-serif italic text-3xl sm:text-4xl text-blush-dusty">{w}</span>
            <LotusMark className="w-6 h-6 opacity-70" stroke="#5B6353" />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
